import React from 'react';
import classes from './RenderBreadcrum.module.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { commercialLangObj, residentialLangObj } from '../../config/DummyData';
import { useTranslation } from 'react-i18next';

const RenderBreadcrum = ({
  data = [],
  type = 'project' // project, property, event
}) => {
  const navigate = useNavigate();
  const { selectedLanguage } = useSelector((state) => state?.languageReducer);
  const { t } = useTranslation('breadCrumb');
  let propertyPurpose = data?.propertyPurpose; // buy,rent
  let propertyClassification =
    data?.propertyType?.type == 'residential' ? residentialLangObj : commercialLangObj; // residential, commercial // propertyClassification
  let province = data?.province;
  let town = data?.town;
  let neighborhood = data?.neighborhood;
  let eventType = data?.eventType;
  let unitType = data?.unitType;

  const handleNavigation = ({
    path,
    sendPurpose = false,
    sendType = false,
    sendProvince = false,
    sendTown = false,
    sendNeightborhood = false,
    sendEventType = false,
    sendUnitType = false
  }) => {
    navigate(`/${path}`, {
      state: {
        ...(sendPurpose && { propertyPurpose: propertyPurpose?.['en'].toLowerCase() }),
        ...(sendType && { propertyClassification: propertyClassification }),
        ...(sendProvince && { province }),
        ...(sendTown && { town }),
        ...(sendNeightborhood && { neighborhood }),
        ...(sendEventType && { eventType }),
        ...(sendUnitType && { unitType })
      }
    });
  };

  return (
    <div className={classes?.breadcrumContainer}>
      {type == 'property' ? (
        <p>
          <span
          onClick={()=> {
            handleNavigation({ path: 'property' });
          }}
          >{t('home')} /{' '}</span>
          <span
          onClick={()=> {
            handleNavigation({
              path: propertyPurpose?.['en'].toLowerCase(),
              sendPurpose: true,
              sendType: true
            });
          }}
          >
          {propertyClassification?.[selectedLanguage]} {t('for')} {propertyPurpose?.[selectedLanguage]}
          </span>
          {/* <span
            onClick={() => {
              handleNavigation({
                path: propertyPurpose?.['en'].toLowerCase(),
                sendPurpose: true,
                sendType: true
              });
            }}>
            {propertyClassification?.[selectedLanguage]}
          </span>{' '}
          {t('for')}{' '}
          <span
            onClick={() => {
              handleNavigation({
                path: propertyPurpose?.['en'].toLowerCase(),
                sendPurpose: true,
                sendType: true
              });
            }}>
            {propertyPurpose?.[selectedLanguage]}
          </span>{' '} */}
          /{' '}
          <span
           onClick={() => {
            handleNavigation({
              path: propertyPurpose?.['en'].toLowerCase(),
              sendPurpose: true,
              sendType: true,
              sendProvince: true
            });
          }}
          >
          {propertyClassification?.[selectedLanguage]} {t('for')} {propertyPurpose?.[selectedLanguage]} {t('in')} {province?.name?.[selectedLanguage]}
          </span>
          {/* <span
            onClick={() => {
              handleNavigation({
                path: propertyPurpose?.['en'].toLowerCase(),
                sendPurpose: true,
                sendType: true
              });
            }}>
            {propertyClassification?.[selectedLanguage]}
          </span>{' '}
          {t('for')}{' '}
          <span
            onClick={() => {
              handleNavigation({
                path: propertyPurpose?.['en'].toLowerCase(),
                sendPurpose: true,
                sendType: true
              });
            }}>
            {propertyPurpose?.[selectedLanguage]}
          </span>{' '}
          {t('in')}{' '}
          <span
            onClick={() => {
              handleNavigation({
                path: propertyPurpose?.['en'].toLowerCase(),
                sendPurpose: true,
                sendType: true,
                sendProvince: true
              });
            }}>
            {province?.name?.[selectedLanguage]}
          </span>{' '} */}
          /{' '}
          <span
          onClick={() => {
            handleNavigation({
              path: propertyPurpose?.['en'].toLowerCase(),
              sendPurpose: true,
              sendType: true,
              sendProvince: true,
              sendTown: true
            });
          }}
          >
          {propertyClassification?.[selectedLanguage]} {t('for')} {propertyPurpose?.[selectedLanguage]} {t('in')} {town?.name?.[selectedLanguage]}
          </span>
          {/* <span
            onClick={() => {
              handleNavigation({
                path: propertyPurpose?.['en'].toLowerCase(),
                sendPurpose: true,
                sendType: true
              });
            }}>
            {propertyClassification?.[selectedLanguage]}
          </span>{' '}
          {t('for')}{' '}
          <span
            onClick={() => {
              handleNavigation({
                path: propertyPurpose?.['en'].toLowerCase(),
                sendPurpose: true,
                sendType: true
              });
            }}>
            {propertyPurpose?.[selectedLanguage]}
          </span>{' '}
          {t('in')}{' '}
          <span
            onClick={() => {
              handleNavigation({
                path: propertyPurpose?.['en'].toLowerCase(),
                sendPurpose: true,
                sendType: true,
                sendProvince: true,
                sendTown: true
              });
            }}>
            {town?.name?.[selectedLanguage]}
          </span>{' '} */}
          /{' '}
          <span
          onClick={() => {
            handleNavigation({
              path: propertyPurpose?.['en'].toLowerCase(),
              sendPurpose: true,
              sendType: true,
              sendProvince: true,
              sendTown: true,
              sendNeightborhood: true
            });
          }}
          >
          {propertyClassification?.[selectedLanguage]} {t('for')} {propertyPurpose?.[selectedLanguage]} {t('in')} {neighborhood?.name?.[selectedLanguage]}
          </span>
          {/* <span
            onClick={() => {
              handleNavigation({
                path: propertyPurpose?.['en'].toLowerCase(),
                sendPurpose: true,
                sendType: true
              });
            }}>
            {propertyClassification?.[selectedLanguage]}
          </span>{' '}
          {t('for')}{' '}
          <span
            onClick={() => {
              handleNavigation({
                path: propertyPurpose?.['en'].toLowerCase(),
                sendPurpose: true,
                sendType: true
              });
            }}>
            {propertyPurpose?.[selectedLanguage]}
          </span>{' '}
          {t('in')}{' '}
          <span
            onClick={() => {
              handleNavigation({
                path: propertyPurpose?.['en'].toLowerCase(),
                sendPurpose: true,
                sendType: true,
                sendProvince: true,
                sendTown: true,
                sendNeightborhood: true
              });
            }}>
            {neighborhood?.name?.[selectedLanguage]}
          </span>{' '} */}
          /{' '}
          <span
            onClick={() => {
              handleNavigation({ path: `property/${data?.slug}` });
            }}>
            {data?.title?.[selectedLanguage]}
          </span>
        </p>
      ) : type == 'event' ? (
        <p>
          <span
          onClick={()=> {
            handleNavigation({ path: 'events' });
          }}
          >{t('home')} /{' '}</span>
          <span
            onClick={() => {
              handleNavigation({ path: 'events' });
            }}>
            {t('events')}
          </span>{' '}
          /{' '}
          <span
          onClick={() => {
            handleNavigation({ path: 'events', sendEventType: true, sendProvince: true });
          }}
          >
{eventType?.title?.[selectedLanguage]} {t('in')} {province?.name?.[selectedLanguage]}
          </span>
          {/* <span
            onClick={() => {
              handleNavigation({ path: 'events', sendEventType: true });
            }}>
            {eventType?.title?.[selectedLanguage]}
          </span>{' '}
          {t('in')}{' '}
          <span
            onClick={() => {
              handleNavigation({ path: 'events', sendEventType: true, sendProvince: true });
            }}>
            {province?.name?.[selectedLanguage]}
          </span>{' '} */}
          /{' '}
          <span
          onClick={() => {
            handleNavigation({
              path: 'events',
              sendEventType: true,
              sendProvince: true,
              sendTown: true
            });
          }}
          >
            {eventType?.title?.[selectedLanguage]} {t('in')} {town?.name?.[selectedLanguage]}
          </span>
          {/* <span
            onClick={() => {
              handleNavigation({ path: 'events', sendEventType: true });
            }}>
            {eventType?.title?.[selectedLanguage]}
          </span>{' '}
          {t('in')}{' '}
          <span
            onClick={() => {
              handleNavigation({
                path: 'events',
                sendEventType: true,
                sendProvince: true,
                sendTown: true
              });
            }}>
            {town?.name?.[selectedLanguage]}
          </span>{' '} */}
          /{' '}
          <span
           onClick={() => {
            handleNavigation({
              path: 'events',
              sendEventType: true,
              sendProvince: true,
              sendTown: true,
              sendNeightborhood: true
            });
          }}
          >
{eventType?.title?.[selectedLanguage]} {t('in')} {neighborhood?.name?.[selectedLanguage]}
          </span>
          {/* <span
            onClick={() => {
              handleNavigation({ path: 'events', sendEventType: true });
            }}>
            {eventType?.title?.[selectedLanguage]}
          </span>{' '}
          {t('in')}{' '}
          <span
            onClick={() => {
              handleNavigation({
                path: 'events',
                sendEventType: true,
                sendProvince: true,
                sendTown: true,
                sendNeightborhood: true
              });
            }}>
            {neighborhood?.name?.[selectedLanguage]}
          </span>{' '} */}
          /{' '}
          <span
            onClick={() => {
              handleNavigation({ path: `events/${data?.slug}` });
            }}>
            {data?.name?.[selectedLanguage]}
          </span>
        </p>
      ) : (
        <p>
          <span
          onClick={()=> {
            handleNavigation({ path: 'projects' });
          }}
          >{t('home')} /{' '}</span>
          <span
            onClick={() => {
              handleNavigation({ path: 'projects' });
            }}>
            {t('projects')}
          </span>{' '}
          /{' '}
          <span
           onClick={() => {
            handleNavigation({ path: 'projects', sendProvince: true });
          }}
          > {t('projects')} {t('in')} {province?.name?.[selectedLanguage]}</span>
          {/* <span
            onClick={() => {
              handleNavigation({ path: 'projects' });
            }}>
            {t('projects')}
          </span>{' '}
          {t('in')}{' '}
          <span
            onClick={() => {
              handleNavigation({ path: 'projects', sendProvince: true });
            }}>
            {province?.name?.[selectedLanguage]}
          </span>{' '} */}
          /{' '}
          <span onClick={() => {
              handleNavigation({
                path: 'projects',
                sendProvince: true,
                sendTown: true
              });
            }}>{t('projects')} {t('in')} {town?.name?.[selectedLanguage]}</span>
          {/* <span
            onClick={() => {
              handleNavigation({ path: 'projects' });
            }}>
            {t('projects')}
          </span>{' '}
          {t('in')}{' '}
          <span
            onClick={() => {
              handleNavigation({
                path: 'projects',
                sendProvince: true,
                sendTown: true
              });
            }}>
            {town?.name?.[selectedLanguage]}
          </span>{' '} */}
          /{' '}
          <span 
          onClick={() => {
            handleNavigation({
              path: 'projects',
              sendProvince: true,
              sendTown: true,
              sendNeightborhood: true
            });
          }}
          >
{t('projects')} {t('in')} {neighborhood?.name?.[selectedLanguage]}
          </span >
          {/* <span
            onClick={() => {
              handleNavigation({ path: 'projects' });
            }}>
            {t('projects')}
          </span>{' '}
          {t('in')}{' '}
          <span
            onClick={() => {
              handleNavigation({
                path: 'projects',
                sendProvince: true,
                sendTown: true,
                sendNeightborhood: true
              });
            }}>
            {neighborhood?.name?.[selectedLanguage]}
          </span>{' '} */}
          /{' '}
          <span
            onClick={() => {
              handleNavigation({ path: `projects/${data?.slug}` });
            }}>
            {data?.name?.[selectedLanguage]}
          </span>
        </p>
      )}
    </div>
  );
};

export default RenderBreadcrum;
